var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.getStatusClass(_vm.item)},[_vm._v("\n  "+_vm._s(_vm.$t('profile-manager.query.status.' + _vm.getStatusMod(_vm.item) ))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }